export enum NotificationTypes {
  GETALL = '@notification/GETALL',
  GETALL_SUCCESS = '@notification/GETALL_SUCCESS',
  GETALL_FAILED = '@notification/GETALL_FAILED',
  UPDATE = '@notification/UPDATE',
  UPDATE_SUCCESS = '@notification/UPDATE_SUCCESS',
  UPDATE_FAILED = '@notification/UPDATE_FAILED',
}
